import { Navigate, useLocation } from 'react-router-dom'
import { useAuthStore } from '../../store/auth.store'

export default function ProtectedRoute({ children, requiredRole = null }) {
  const { isAuthenticated, user } = useAuthStore()
  const location = useLocation()

  if (!isAuthenticated) {
    const targetUrl = location.pathname + location.search
    return (
      <Navigate
        to={`/login?redirect=${encodeURIComponent(targetUrl)}`}
        state={{ from: location }}
        replace
      />
    )
  }

  if (requiredRole && user?.role !== requiredRole) {
    return <Navigate to="/" replace />
  }

  return children
}
